var _path, _circle, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoausencia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 0.00527599C15.7952 0.0156034 15.7105 0.0362572 15.6294 0.06311L0.941817 5.00566C0.383361 5.18949 0 5.76367 0 6.41636C0 7.06904 0.383361 7.6432 0.941817 7.82705L6.70898 9.76855V18.9597C6.70898 22.4833 8.29404 25.6018 10.7085 27.4736C5.08145 29.8819 1.08742 35.9954 1.08742 43.1604V45.5356L1.08927 45.5377C1.09111 46.3432 1.67353 46.9959 2.39416 47H29.6772C30.3978 46.9959 30.9802 46.3432 30.9839 45.5377V43.1625C30.9839 35.9811 26.9697 29.855 21.3208 27.4593C23.7205 25.5859 25.2964 22.4734 25.2964 18.9623V14.8852H25.2945C25.2964 14.8625 25.2964 14.8418 25.2945 14.8212V9.76919L29.3769 8.39567V12.165H29.3788C29.3769 12.5533 29.5133 12.9292 29.7585 13.206C30.0036 13.4807 30.3372 13.6377 30.6837 13.6398C31.032 13.6377 31.3656 13.4828 31.6107 13.206C31.8558 12.9293 31.9941 12.5554 31.9922 12.165V6.58414C32.0309 6.18758 31.924 5.78689 31.6955 5.48123C31.6844 5.46677 31.6734 5.45231 31.6623 5.43785C31.6291 5.39654 31.5941 5.3573 31.5573 5.32012C31.5462 5.30979 31.537 5.29947 31.5259 5.29121C31.5241 5.28708 31.5204 5.28501 31.5185 5.28294C31.5038 5.26849 31.4872 5.25403 31.4725 5.23957C31.4467 5.21892 31.4227 5.20033 31.3951 5.18174C31.2919 5.10532 31.1813 5.04748 31.0633 5.00618L31.032 4.99378V4.99585C31.0154 4.98965 31.0006 4.98552 30.9841 4.98139L16.3852 0.0636367C16.2212 0.00786995 16.0498 -0.0107153 15.8802 0.00580268L15.88 0.00527599ZM9.33177 10.6484L15.6297 12.7676V12.7696C15.8749 12.8522 16.1384 12.8522 16.3854 12.7696L22.6758 10.6526V13.7362C18.3557 15.4485 13.654 15.4485 9.33394 13.7362L9.33177 10.6484ZM9.33177 16.8818C13.6759 18.3792 18.3314 18.3792 22.6737 16.8818V18.9596C22.6737 23.076 19.7174 26.3785 16.035 26.3785H15.9687C12.288 26.3785 9.33006 23.0779 9.33006 18.9596L9.33177 16.8818ZM15.9704 29.3158H16.0367C22.8891 29.3158 28.3633 35.4646 28.3633 43.1605V44.061H3.71022V43.1605C3.71022 35.4894 9.14917 29.3555 15.9704 29.3158Z",
    fill: "#21A598"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1064,
    cy: 40.248,
    r: 11.7519,
    fill: "#21A598"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 45.4658,
    width: 16.4113,
    height: 2.05939,
    rx: 1.0297,
    transform: "rotate(-45 25.7266 45.4658)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 45.4658,
    width: 16.4113,
    height: 2.05939,
    rx: 1.0297,
    transform: "rotate(-45 25.7266 45.4658)",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.4113,
    height: 2.05939,
    rx: 1.0297,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 38.7896 45.4658)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16.4113,
    height: 2.05939,
    rx: 1.0297,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 38.7896 45.4658)",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoausencia);
export default __webpack_public_path__ + "static/media/iconoausencia.33f5b494a41ca5a7c5d5ae57a823c892.svg";
export { ForwardRef as ReactComponent };